import { call, put, takeLatest } from 'redux-saga/effects';

import { sendContactFormDataApi } from '../../api';
import {
  contactFormSubmit,
  contactFormSubmitSuccess,
  contactFormSubmitError,
} from '../slices/contactFormSlice';

function* contactFormSubmitWorker(action) {
  try {
    const { status, ok, data } = yield call(
      sendContactFormDataApi,
      action.payload,
    );

    if (ok) {
      yield put(contactFormSubmitSuccess(data));
    } else {
      yield put(contactFormSubmitError({ status, data }));
    }
  } catch (err) {
    yield put(contactFormSubmitError(err.message));
  }
}

export default function* contactFormSaga() {
  yield takeLatest(contactFormSubmit.type, contactFormSubmitWorker);
}
